(function () {
  'use strict';
  function normalizeText(v) { return (v || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function isHeading(el) { return el && /^H[1-6]$/.test(el.tagName); }

  function extractOldSpecs(root) {
    var source = root.querySelector('[data-jce-details-description-source]');
    if (!source || !source.content) return null;
    var clone = source.content.cloneNode(true);
    var headings = Array.from(clone.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    var heading = headings.find(function (el) { return ['specifications', 'technical specifications', 'performance specifications'].includes(normalizeText(el.textContent)); });
    // Use the exact "Specifications" heading, not an earlier "Technical Specifications" heading.
    if (!heading) return null;
    var sibling = heading.nextElementSibling;
    for (var attempts = 0; sibling && attempts < 12; sibling = sibling.nextElementSibling, attempts++) {
      if (isHeading(sibling)) break;
      var table = sibling.matches('table') ? sibling : sibling.querySelector('table');
      if (table && table.querySelectorAll('tr').length) return table.cloneNode(true);
    }
    // Sometimes the heading and table sit inside a nested wrapper.
    var wrapper = heading.parentElement;
    if (wrapper && wrapper !== clone && wrapper.querySelector('table')) {
      return wrapper.querySelector('table').cloneNode(true);
    }
    return null;
  }

  // Convert a normal label/value specification table into two label/value pairs per row.
  // Existing 4-cell rows are preserved, so a real four-column table stays unchanged.
  function pairSpecRows(table) {
    if (!table) return;
    var body = table.tBodies && table.tBodies[0];
    if (!body) return;
    var rows = Array.from(body.rows);
    if (!rows.length) return;
    var counts = rows.map(function (row) { return row.cells.length; });
    var alreadyPaired = counts.every(function (count) { return count === 4; });
    var canPair = rows.length > 1 && counts.every(function (count) { return count === 2; }) &&
      rows.every(function (row) { return Array.from(row.cells).every(function (cell) { return cell.colSpan === 1 && cell.rowSpan === 1; }); });
    if (!alreadyPaired && !canPair) return; // Keep unusual/nested tables intact.

    if (canPair) {
      for (var i = 0; i + 1 < rows.length; i += 2) {
        var left = rows[i];
        var right = rows[i + 1];
        while (right.firstElementChild) left.appendChild(right.firstElementChild);
        right.remove();
      }
      if (rows.length % 2 === 1) {
        // Keep the final unpaired label/value left-aligned on desktop.
        var last = rows[rows.length - 1];
        for (var j = 0; j < 2; j++) {
          var empty = document.createElement('td');
          empty.className = 'jce-details-v2__blank-spec';
          empty.setAttribute('aria-hidden', 'true');
          last.appendChild(empty);
        }
      }
    }

    table.classList.add('jce-details-v2__spec-table', 'jce-details-v2__spec-table--paired');
    // The original description table may have fixed widths set in Shopify's rich-text editor.
    table.removeAttribute('width');
    table.querySelectorAll('colgroup, col').forEach(function (el) { el.remove(); });
    table.querySelectorAll('td, th').forEach(function (cell) {
      cell.removeAttribute('width');
      cell.style.removeProperty('width');
      cell.style.removeProperty('min-width');
      cell.style.removeProperty('max-width');
    });
  }

  function setup(root) {
    if (root.dataset.jceDetailsReady === 'yes') return;
    root.dataset.jceDetailsReady = 'yes';
    var tabs = Array.from(root.querySelectorAll('[data-jce-details-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-jce-details-panel]'));
    var specTarget = root.querySelector('[data-jce-details-spec-target]');
    var specProcessed = false;
    function hydrateSpecifications() {
      if (specProcessed || !specTarget) return;
      specProcessed = true;
      var custom = specTarget.querySelector('[data-jce-details-custom-spec]');
      var fallback = specTarget.querySelector('[data-jce-details-fallback-spec]');
      var empty = specTarget.querySelector('[data-jce-details-no-spec]');
      // The product metafields are the source of truth. Do not replace them with
      // an older Description table just because one exists.
      if (fallback && fallback.querySelector('tbody tr')) {
        pairSpecRows(fallback);
        if (custom) custom.hidden = true;
        return;
      }
      // Only products without any of the configured metafields use legacy content.
      if (custom && normalizeText(custom.textContent)) {
        custom.querySelectorAll('table').forEach(pairSpecRows);
        if (fallback) fallback.hidden = true;
        return;
      }
      var oldTable = extractOldSpecs(root);
      if (oldTable) {
        oldTable.removeAttribute('style');
        oldTable.className = 'jce-details-v2__spec-table';
        pairSpecRows(oldTable);
        if (fallback) fallback.replaceWith(oldTable);
        return;
      }
      if (fallback) fallback.hidden = true;
      if (empty) empty.hidden = false;
    }
    function select(tab, shouldFocus) {
      if (!tab) return;
      var name = tab.getAttribute('data-jce-details-tab');
      tabs.forEach(function (t) {
        var active = (t === tab);
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', String(active));
        t.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-jce-details-panel') !== name; });
      if (name === 'specs') hydrateSpecifications();
      if (shouldFocus) tab.focus();
    }
    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (event) {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        var next = idx;
        if (event.key === 'ArrowRight') next = (idx + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        select(tabs[next], true);
      });
    });
    // Deep links from other page elements can activate the appropriate tab.
    if (location.hash && /(?:reviews|specifications|downloads)/i.test(location.hash)) {
      var slug = /review/i.test(location.hash) ? 'reviews' : /download/i.test(location.hash) ? 'downloads' : 'specs';
      select(tabs.find(function(t) { return t.getAttribute('data-jce-details-tab') === slug; }), false);
    }
  }
  function init(container) {
    if (container.matches && container.matches('[data-jce-details-v2]')) setup(container);
    if (container.querySelectorAll) container.querySelectorAll('[data-jce-details-v2]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
